module.exports = __webpack_public_path__ + "static/media/badge.6528e2dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Menu/img/badge.svg
// module id = 134
// module chunks = 0